import React from 'react'
import './InsurancePlansHeroSection.component.scss'

const InsurancePlansHeroSection = ({ headline, subtitle, headlineMobile }) => {
  return (
    <section className='insurance-plans-hero-section'>
      <div className='insurance-plans-hero-section__outer'>
        <div className='insurance-plans-hero-section__inner'>
          <h1 className='insurance-plans-hero-section__headline'>
            {headlineMobile ? (
              <>
                <span className='insurance-plans-hero-section__headline-desktop'>{headline}</span>
                <span className='insurance-plans-hero-section__headline-mobile'>{headlineMobile}</span>
              </>
            ) : (
              <span>{headline}</span>
            )}
          </h1>

          {subtitle && (
            <p className='insurance-plans-hero-section__subtitle'>
              <span>{subtitle}</span>
            </p>
          )}
        </div>
      </div>
    </section>
  )
}

export default InsurancePlansHeroSection
